import { useTranslation } from 'react-i18next';

import { DownloadReport, Layout, Patient } from '../../../components/app';
import { useFetchPatients } from '../../../features/patients';

export const PatientPage = () => {
  const { t } = useTranslation();

  useFetchPatients();

  return (
    <Layout
      backButton={{ title: t('patients.title'), path: '/app/patients' }}
      rightButtons={[<DownloadReport key="download" />]}
    >
      <Patient />
    </Layout>
  );
};
